import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-fluid p-formgrid p-grid p-m-4"
}
const _hoisted_2 = { class: "p-field p-col-6 p-mb-6" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = {
  for: "jobName",
  class: "kn-material-input-label"
}
const _hoisted_5 = {
  key: 0,
  class: "p-error "
}
const _hoisted_6 = { class: "p-field p-col-6 p-mb-6" }
const _hoisted_7 = { class: "p-float-label" }
const _hoisted_8 = {
  for: "jobDescription",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_SchedulerDocumentsTable = _resolveComponent("SchedulerDocumentsTable")
  const _component_SchedulerTimingOutputTable = _resolveComponent("SchedulerTimingOutputTable")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-m-0" }, {
      start: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.job.jobName), 1)
      ]),
      end: _withCtx(() => [
        _createVNode(_component_Button, {
          icon: "pi pi-save",
          class: "p-button-text p-button-rounded p-button-plain",
          disabled: _ctx.saveDisabled,
          onClick: _ctx.saveJob,
          "data-test": "save-button"
        }, null, 8, ["disabled", "onClick"]),
        _createVNode(_component_Button, {
          icon: "pi pi-times",
          class: "p-button-text p-button-rounded p-button-plain",
          onClick: _ctx.closeJobDetail
        }, null, 8, ["onClick"])
      ]),
      _: 1
    }),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ProgressBar, {
          key: 0,
          mode: "indeterminate",
          class: "kn-progress-bar",
          "data-test": "progress-bar"
        }))
      : _createCommentVNode("", true),
    (_ctx.job)
      ? (_openBlock(), _createBlock(_component_Card, {
          key: 1,
          id: "scheduler-detail-card",
          class: "p-m-2"
        }, {
          content: _withCtx(() => [
            (_ctx.job)
              ? (_openBlock(), _createBlock("form", _hoisted_1, [
                  _createVNode("div", _hoisted_2, [
                    _createVNode("span", _hoisted_3, [
                      _createVNode(_component_InputText, {
                        id: "jobName",
                        class: ["kn-material-input", {
                                'p-invalid': _ctx.job.jobName?.length === 0 && _ctx.jobNameDirty
                            }],
                        modelValue: _ctx.job.jobName,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.job.jobName = $event)),
                        modelModifiers: { trim: true },
                        maxLength: "80",
                        disabled: _ctx.testReadonly,
                        onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.jobNameDirty = true)),
                        "data-test": "name-input"
                      }, null, 8, ["modelValue", "class", "disabled"]),
                      _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('managers.scheduler.packageName')) + " *", 1)
                    ]),
                    (_ctx.job.jobName?.length === 0 && _ctx.jobNameDirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_5, _toDisplayString(_ctx.$t('common.validation.required', { fieldName: _ctx.$t('managers.scheduler.packageName') })), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_6, [
                    _createVNode("span", _hoisted_7, [
                      _createVNode(_component_InputText, {
                        id: "jobDescription",
                        class: "kn-material-input",
                        maxLength: "120",
                        modelValue: _ctx.job.jobDescription,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.job.jobDescription = $event)),
                        modelModifiers: { trim: true }
                      }, null, 8, ["modelValue"]),
                      _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('managers.scheduler.packageDescription')), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_SchedulerDocumentsTable, {
              class: "p-mt-4",
              jobDocuments: _ctx.job.documents,
              onLoading: _ctx.setLoading
            }, null, 8, ["jobDocuments", "onLoading"]),
            (_ctx.job.edit)
              ? (_openBlock(), _createBlock(_component_SchedulerTimingOutputTable, {
                  key: 1,
                  class: "p-mt-4",
                  job: _ctx.job,
                  onLoading: _ctx.setLoading,
                  onTriggerSaved: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('triggerSaved')))
                }, null, 8, ["job", "onLoading"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}